// extracted by mini-css-extract-plugin
var _1 = "fPJFo__arrow";
export { _1 as "arrow" }
